(function() {
  function initProductTabs() {
    document.addEventListener('click', function(e) {
      const link = e.target.closest('.product-nav-link');
      if (link) {
        e.preventDefault();
        const tabItem = link.closest('.product-tab-item');
        const productTabContainer = link.closest('.product-tab');
        if (!tabItem || !productTabContainer) return;

        const targetHash = link.getAttribute('data-href');
        if (!targetHash) return;

        const allItems = productTabContainer.querySelectorAll('.product-tab-item');
        allItems.forEach(function(item) { item.classList.remove('active'); });

        tabItem.classList.add('active');

        const allPanes = productTabContainer.querySelectorAll('.product-tab-pane');
        allPanes.forEach(function(pane) { pane.classList.remove('active'); });

        const targetPane = productTabContainer.querySelector(targetHash);
        if (targetPane) {
          targetPane.classList.add('active');
        }
        return;
      }

      const faqSummary = e.target.closest('.product-tab-faq__question-summary');
      if (faqSummary) {
        e.preventDefault();
        const faqItem = faqSummary.closest('.product-tab-faq__item');
        const details = faqSummary.closest('details');
        const accordion = faqSummary.closest('.product-tab-faq__accordion');
        if (!faqItem || !details) return;

        const isOpen = details.hasAttribute('open');
        const collapseOthers = accordion && accordion.getAttribute('data-collapse-others') === 'true';

        if (collapseOthers) {
          const allItems = accordion.querySelectorAll('.product-tab-faq__item');
          allItems.forEach(function(otherItem) {
            if (otherItem !== faqItem) {
              otherItem.classList.remove('is-active');
              const otherDetails = otherItem.querySelector('details');
              if (otherDetails) {
                otherDetails.removeAttribute('open');
              }
            }
          });
        }

        if (isOpen) {
          faqItem.classList.remove('is-active');
          details.removeAttribute('open');
        } else {
          details.setAttribute('open', '');
          faqItem.classList.add('is-active');
        }
        return;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductTabs);
  } else {
    initProductTabs();
  }
})();